import type { Client } from './api/client';
import { getUsersByPermission } from './api';

/** Permission slug for users who may work intakes (aligns with intake page `intake:access` checks). */
export const INTAKE_ASSIGNEE_RBAC_PERMISSION_SLUG = 'intake:assignable';

/**
 * Users eligible to appear in intake assignee pickers.
 */
export function fetchIntakeAssignableUsers(client: Client) {
  return getUsersByPermission({
    client,
    query: { permission: INTAKE_ASSIGNEE_RBAC_PERMISSION_SLUG },
  });
}
